exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "input[type=checkbox]{transform:scale(1.5)}@media(max-width:767px){.mobile-padding{padding:20px!important}}.reg-class{font-size:4vw!important}@media(min-width:400px){.reg-class{font-size:16px!important}}.disabled-cb{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38a1e412","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/app/main/components/pages/checkout/FlowData.vue
// module id = 70
// module chunks = 0 1 2